import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { EmptyListIcon } from '@systemeio/ui/icons';
const EmptyFunnelStepList = () => {
  const $ = _c(12);
  const {
    t
  } = useLocoTranslation();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <EmptyListIcon />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== t) {
    t1 = t("dashboard.funnel.configuration.common.list.empty_title.first_line");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <span className="text-text-primary text-base">{t1}</span>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t("dashboard.funnel.configuration.common.list.empty_title.list.empty_list");
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <span className="text-text-primary text-base">{t3}</span>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t2 || $[10] !== t4) {
    t5 = <div className="gap-3py-20 bg-background-secondary flex w-full flex-col items-center justify-center rounded-lg pb-10">{t0}<div className="flex flex-col items-center">{t2}{t4}</div></div>;
    $[9] = t2;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
};
export default EmptyFunnelStepList;